import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskListEdit1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-list-edit-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.63,14.88,15,22.51l-3.75.75L12,19.51l7.631-7.63a2.115,2.115,0,0,1,2.991,0l.009.009A2.115,2.115,0,0,1,22.63,14.88Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.249,
			y1: 10.51,
			x2: 14.249,
			y2: 10.51
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.249,
			y1: 14.26,
			x2: 11.249,
			y2: 14.26
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.249,
			y1: 18.01,
			x2: 8.249,
			y2: 18.01
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.249,23.26h-6a1.5,1.5,0,0,1-1.5-1.5V6.01a1.5,1.5,0,0,1,1.5-1.5H6a3.75,3.75,0,0,1,7.5,0h3.75a1.5,1.5,0,0,1,1.5,1.5V8.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.749,3.76a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375"
		})
	]
});
export default SvgTaskListEdit1;
